import catalog from '@/uptk/modules/module-studio/catalog/capability-catalog.v1.json';
import runtime from '../module-runtime.json';
const LIBRARIES = new Set(['react', ...catalog.libraries.filter(l => l.allowedInCode).map(l => l.name)]);
const RUNTIME = new Set<string>(runtime.imports);
/** Local specifiers must be resolved against the actual module file inventory by the caller. */
export function unknownImports(source: string, moduleFiles: readonly string[] = []): { match: string; index: number }[] {
 const tokens = [...source.matchAll(/\/\*[\s\S]*?\*\/|\/\/[^\r\n]*|"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`|[A-Za-z_$][\w$]*|[^\s]/g)].filter(t => !t[0].startsWith('//') && !t[0].startsWith('/*'));
 const errors: { match: string; index: number }[] = [];
 const local = new Set(moduleFiles);
 const admitted = (name: string) => !name.includes(String.fromCharCode(92)) && !name.includes(String.fromCharCode(0)) && (local.has(name) || RUNTIME.has(name) || [...LIBRARIES].some(p => name === p || name.startsWith(p + '/')) || name.startsWith('@/design-system/ds-0/') || name === '@/uptk/core/components/ui' || name.startsWith('@/uptk/core/components/ui/')) && (!name.split('/').includes('..') || local.has(name));
 const literal = (value: string) => /^['"]/.test(value) && !value.includes('\\');
 for (let i = 0; i < tokens.length; i += 1) {
  const token = tokens[i], kind = token[0];
  // Template interpolation executes code; do not hide dynamic loading inside a string token.
  if (kind.startsWith('`') && kind.includes('${') && /\b(?:import|require)\s*\(/.test(kind)) errors.push({ match: kind, index: token.index ?? 0 });
  if (!['import', 'export', 'require'].includes(kind) || (kind !== 'require' && tokens[i - 1]?.[0] === '.')) continue;
  if (tokens[i + 1]?.[0] === '(') {
   const value = tokens[i + 2]?.[0] ?? '', name = value.slice(1, -1);
   if (kind !== 'import' || !literal(value) || tokens[i + 3]?.[0] !== ')' || !local.has(name) || !admitted(name)) errors.push({ match: kind + '(', index: token.index ?? 0 });
   continue;
  }
  if (kind === 'require') continue;
  let target: RegExpMatchArray | undefined = tokens[i + 1];
  if (!target || !/^['"]/.test(target[0])) {
   target = undefined;
   for (let j = i + 1; j < tokens.length && ![';', 'import', 'export'].includes(tokens[j][0]); j += 1) {
    if (tokens[j][0] === 'from') { target = tokens[j + 1]; break; }
   }
  }
  if (target && /^['"]/.test(target[0])) {
   const name = target[0].slice(1, -1);
   if (!literal(target[0]) || !admitted(name)) errors.push({ match: name, index: token.index ?? 0 });
  }
 }
 return errors;
}
